import {
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TableHeader,
  TableRow,
} from "../ui/table";
import { Input } from "../ui/input";
import { FC, FormEvent, useEffect } from "react";
import { formTable } from "@/interface/dataInterface";

const CustomTable: FC<formTable> = ({
  data,
  setData,
  columns,
  leadProp,
  secondProp,
  otherProps,
  footer,
}) => {
  return (
    <div className="mt-5 max-h-60 overflow-y-auto w-full">
      {data && data.length > 0 && (
        <Table className="min-w-full table-auto">
          <TableHeader>
            <TableRow>
              {columns.map((column) => (
                <TableHead key={column}>{column}</TableHead>
              ))}
            </TableRow>
          </TableHeader>
          <TableBody className="w-full">
            {data &&
              data.map((item) => (
                <TableRow key={item.id}>
                  <TableCell className="w-full text-left">
                    {item[leadProp]} {secondProp && item[secondProp]}
                  </TableCell>
                  {otherProps &&
                    otherProps.map((row) => (
                      <TableCell>
                        <Input
                          className="w-20 text-right"
                          onChange={(e: FormEvent<HTMLInputElement>) => {
                            const { type, value } = e.currentTarget;
                            setData((prev: any[]) =>
                              prev.map((i) =>
                                i.id === item.id
                                  ? {
                                      ...i,
                                      [row.prop]:
                                        type == "number"
                                          ? Number(value)
                                          : value,
                                    }
                                  : i,
                              ),
                            );
                          }}
                          id={item.id}
                          type={row.type ? row.type : "number"}
                          value={item[row.prop] || ""}
                          required
                        />
                      </TableCell>
                    ))}
                </TableRow>
              ))}
          </TableBody>
          {footer}
        </Table>
      )}
    </div>
  );
};

export default CustomTable;
